import { Dashboard } from "@/components/dashboard/Dashboard/Dashboard";
import { VStack } from "@/components/layout/VStack";
import { useLoadDashboard } from "../hooks/dashboard/useLoadDashboard";
import { useEffect, useState } from "react";
import { UpcomingExplorations } from "../components/dashboard/UpcomingExplorations/UpcomingExplorations";
import { Attendance } from "../components/dashboard/Attendance/Attendance";

export type UpcomingExplorationsData = {
  _id: string;
  name: string;
  description: string;
  gradeLevels: number[];
  pathway: string;
  room: string;
  minEnrollment: number;
  maxEnrollment: number;
  enrolled: number;
  teacher: string;
  coTeachers: string[];
  session: {
    _id: string;
    name: string;
    rotation: string;
    singleton: string;
  };
  class: any;
};

export type AttendanceRotations = {
  _id: string;
  date: string;
  records: number;
  present: number;
  sessions: {
    _id: string;
    name: string;
    records: number;
    present: number;
    absentStudents: {
      _id: string;
      name: string;
      gradeLevel: string;
    }[];
    classes: any[];
  }[];
};

export type AttendanceData = {
  totals: {
    records: number;
    present: number;
  };
  rotations: AttendanceRotations[];
};

const TeacherDashboard = () => {
  const [upcomingExplorations, setUpcomingExplorations] = useState<{
    data: any;
    teachers: any[];
  }>({ data: undefined, teachers: [] });
  const [attendance, setAttendance] = useState<AttendanceData | null>(null);

  const { loadUpcomingExplorations, loadAttendance, loading } =
    useLoadDashboard();

  useEffect(() => {
    loadUpcomingExplorations(setUpcomingExplorations);
    loadAttendance(setAttendance);
  }, []);

  return (
    <Dashboard activePage="/dashboard">
      <VStack>
        <h2
          style={{
            fontSize: "var(--text-2xl)",
            lineHeight: "var(--line-height-2xl)",
            fontWeight: "var(--font-bold)",
          }}
        >
          Teacher Dashboard
        </h2>
        <p style={{ color: "var(--muted-foreground)" }}>
          View your upcoming explorations and attendance stats.
        </p>
      </VStack>
      <UpcomingExplorations
        data={upcomingExplorations}
        loading={loading.upcomingExplorations}
      />
      <Attendance data={attendance} loading={loading.attendance} />
    </Dashboard>
  );
};

export default TeacherDashboard;
